import { isAnyOf } from "@reduxjs/toolkit";

import { startAppListening } from "../../listener";
import { uiActions } from "../ui/slice";
import { currentPlaylistSelector } from "./selectors";
import { playlistActions } from "./slice";
import { playlistDB } from "./database";
import { accountStateSelector } from '../account/api';

export const startPlaylistAdvancer = () => {
  return startAppListening({
    actionCreator: uiActions.setCurrentLiveResource,
    effect: (action, api) => {
      if (action.payload?.annotations?.playlistIndex !== undefined) {
        const state = api.getState();
        const playlistPosition = action.payload.annotations.playlistIndex as number;
        const playlist = currentPlaylistSelector(state);

        if (playlist.items.length > playlistPosition + 1) {
          const nextItem = playlist.items[playlistPosition + 1];

          const nextResource = nextItem.resource || state.resources[nextItem.resourceID!];

          api.dispatch(uiActions.setCurrentPreviewResource({
            resource: nextResource,
            annotations: {
              playlistIndex: playlistPosition + 1
            }
          }));
        }

      }

    }
  });
};

export const autoSavePlaylists = () => {
  return startAppListening({
    matcher: isAnyOf(
      playlistActions.addItem,
      playlistActions.moveItem,
      playlistActions.clearPlaylist,
      playlistActions.setItemTheme,
      playlistActions.loadPlaylist,
      playlistActions.saveCurrentPlaylist,
      playlistActions.deletePlaylist
    ),
    effect: (_, api) => {
      const state = api.getState();
      const accountState = accountStateSelector(state);

      if (accountState.data?.id) {
        const currentPlaylist = state.playlist.current;
        const accountID = accountState.data.id;

        playlistDB.playlists.put({
          ...currentPlaylist,
          id: 'CURRENT',
          accountID
        });

        playlistDB.playlists.bulkPut(
          Object.entries(state.playlist.savedPlaylists).map(
            ([key, playlist]) => ({
              ...playlist,
              id: key,
              accountID
            })
          )
        );

      }
    }
  });
};
